export const FETCH_WORKFLOW_STATUS_LIST = 'FETCH_WORKFLOW_STATUS_LIST';
export const FETCH_WORKFLOW_STATUS_LIST_SUCCESS =
  'FETCH_WORKFLOW_STATUS_LIST_SUCCESS';
export const FETCH_WORKFLOW_STATUS_LIST_FAIL =
  'FETCH_WORKFLOW_STATUS_LIST_FAIL';
export const UPDATE_WORKFLOW_STATUS_LIST = 'UPDATE_WORKFLOW_STATUS_LIST';
export const UPDATE_WORKFLOW_STATUS_LIST_SUCCESS =
  'UPDATE_WORKFLOW_STATUS_LIST_SUCCESS';
export const UPDATE_WORKFLOW_STATUS_LIST_FAIL =
  'UPDATE_WORKFLOW_STATUS_LIST_FAIL';
export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL';

export const fetchWorkFlowStatusList = () => ({
  type: FETCH_WORKFLOW_STATUS_LIST
});

export const fetchWorkFlowStatusListSuccess = (statusList) => ({
  type: FETCH_WORKFLOW_STATUS_LIST_SUCCESS,
  payload: statusList
});

export const fetchWorkFlowStatusListFail = (payload) => ({
  type: FETCH_WORKFLOW_STATUS_LIST_FAIL,
  payload: payload
});

export const updateWorkFlowStatusList = (statusList) => ({
  type: UPDATE_WORKFLOW_STATUS_LIST,
  payload: statusList
});

export const updateWorkFlowStatusListSuccess = (statusList) => ({
  type: UPDATE_WORKFLOW_STATUS_LIST_SUCCESS,
  payload: statusList
});

export const updateWorkFlowStatusListFail = (payload) => ({
  type: UPDATE_WORKFLOW_STATUS_LIST_FAIL,
  payload: payload
});

export const closeSuccessModal = () => ({
  type: CLOSE_SUCCESS_MODAL
});
